<div class="container">
  <div class="logo"></div>
  <div class="login-container">
      <mat-card class="login">
          <mat-card-title>Welcome</mat-card-title>
          <mat-card-content>
              <p>Login with your account to continue</p>
              <button
                  mat-raised-button
                  color="primary"
                  autofocus
                  (click)="login()">
                  Login
              </button>
          </mat-card-content>
      </mat-card>
  </div>
</div>